import webBackApi from '../../api/webBackApi';

const API_PATH = "/api/download-images";

export const requestDownloadAll = async (customerId, ftpUser) => {
  try {
    const response = await webBackApi.post(API_PATH, {
      customerId,
      ftpUser,
    });
    return response.data;
  } catch (error) {
    console.error("Error requesting download all:", error);
    throw error;
  }
};

export const requestDownloadByDateRange = async (
  customerId,
  ftpUser,
  fechaDesde,
  fechaHasta
) => {
  try {
    const response = await webBackApi.post(`${API_PATH}/range`, {
      customerId,
      ftpUser,
      fechaDesde,
      fechaHasta,
    });
    return response.data;
  } catch (error) {
    console.error("Error requesting download by date range:", error);
    throw error;
  }
};

export const getDownloadStatus = async (customerId, ftpUser, type = "all") => {
  try {
    const response = await webBackApi.get(
      `${API_PATH}/${customerId}/${ftpUser}/status`,
      {
        params: { type },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting download status:", error);
    throw error;
  }
};

export const pollDownloadStatus = async (
  customerId,
  ftpUser,
  type = "all",
  maxPolls = 15,
  intervalMs = 60000
) => {
  let pollCount = 0;

  return new Promise((resolve, reject) => {
    const poll = async () => {
      try {
        pollCount++;
        const status = await getDownloadStatus(customerId, ftpUser, type);

        if (
          status.estado === "COMPLETADO" ||
          status.estado === "LISTO" ||
          status.estado === "ERROR" ||
          status.estado === "COMPLETADO_CON_ERRORES"
        ) {
          clearInterval(pollInterval);
          resolve(status);
        } else if (pollCount >= maxPolls) {
          clearInterval(pollInterval);
          reject(
            new Error(
              `Download polling timeout after ${maxPolls} attempts (${(maxPolls * intervalMs) / 60000} minutes)`
            )
          );
        }
      } catch (error) {
        clearInterval(pollInterval);
        reject(error);
      }
    };

    const pollInterval = setInterval(poll, intervalMs);
    poll();
  });
};
